<template>
    <v-content>  
     <v-card v-if="!loading" style="padding: 20px; margin-top: 10px;">
      <v-row v-if="loading" cols="12" justify="center">
				<v-col class="mx-auto" cols="12">
					<v-skeleton-loader type="table-tbody" class="mx-auto" max-width="90%"/>
				</v-col>
			</v-row>

      <div class="d-flex" v-if="!loading" 
				style="position: absolute; top:10px; right:10px; color:#065535; font-size:0.7em; cursor:pointer;"
				@click="refreshAll()">
          <span>{{updateTime}}</span>
          <v-icon class="primary--text" style="padding-left:4px; font-size:1.6em">
						mdi-refresh
					</v-icon>
      </div>
             
		<v-row v-if="!loading">
          <v-col cols="12" sm="3" md="3" style="max-height: 100px;">
					<v-card 
                     elevation="0"
                    >
						<v-card-text style="padding: 0 16px;">
							<div class="primary--text">Últimos archivos subidos</div>
							<p class="display-2 text--primary" style="font-weight: 300;">{{ homeStats.totalUploaded }}</p>
						</v-card-text>
					</v-card>
				</v-col>

          <v-col cols="12" sm="3" md="3" style="max-height: 100px;">
            <v-card 
              elevation="0"
            >
              <v-card-text style="padding: 0 16px;">
                <div class="primary--text">Últimos archivos validados</div>
                <p class="display-2 text--primary" style="font-weight: 300;">{{ homeStats.totalValidated }}</p>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="3" md="3" offset="3">
          <v-text-field style="padding-top: 30px;"
						v-model="search"
						append-icon="mdi-magnify"
						label="Buscar"
                        single-line
						hide-details
						:clearable="true"
						@click:clear="searchTimeOut()"
						@keyup="searchTimeOut()"/>
                        
				</v-col>
      </v-row>

			<v-row v-if="!isLoading && !errorMessage" justify="center" class="mt-1">
				<v-col class="mx-auto" cols="12">
					<v-data-table
						:headers="headers"
						:items="documents"
						:options.sync="options"
						:server-items-length="totalDocuments"
						:footer-props="{
							'items-per-page-options': [5, 10, 15]
						}"
						:loading="apiLoading"
						class="elevation-0"
						sortBy="creationDate"
						update: sort-desc
            style="border: thin solid rgba(0, 0, 0, 0.12);">
						<template v-slot:[`item.creationDate`]="{ item }">
							{{ formatLocalDateTime(item.creationDate) }}
						</template>
						<template v-slot:[`item.validityStartDate`]="{ item }">
							{{ formatLocalDate(item.validityStartDate) }}
						</template>
						<template v-slot:[`item.validityFinishDate`]="{ item }">
							{{ formatLocalDate(item.validityFinishDate) }}
						</template>
						<template v-slot:[`item.enabled`]="{ item }">
							{{ item.enabled ? 'Sí' : 'No' }}
						</template>
						<template v-slot:[`item.actions`]="{ item }">
							<v-icon
								dense
								color="primary"
								:disabled="disableDownloadIcon || !item.filePath || item.fileSize == 0"
								@click="downloadFile(item)">
								mdi-download
							</v-icon>	
							<v-icon
							class="ml-4"
								dense
								color="primary"
								@click="openEditDocumentDialog(item)">
								mdi-pencil
							</v-icon>							
						</template>
					</v-data-table>
				</v-col>
			</v-row>
    </v-card>

		<v-btn
			@click="openCreateDocumentDialog()"
			dark
			fixed
			bottom
			right
			fab
			color="primary">
			<v-icon dark>mdi-plus</v-icon>
		</v-btn>
      
    <DocumentDialog ref="documentDialog"/>

  </v-content>
</template>

<script>
import api from '../../../api/icoev';
import BaseModule from '../../common/BaseModule';
import DocumentDialog from "./DocumentDialog";

  export default {
      components: {
        DocumentDialog
      },
      name: 'HomeMain',
      mixins: [BaseModule],
    data () {
      return {
        loading: false,
        updateTime: null,
				search: null,
				options: { itemsPerPage: 10 },
				timer: null,
				isLoading: false,
				apiLoading: false,
				errorMessage: null,
				totalDocuments: 0,
        homeStats: {
            totalUploaded: 0,
            totalValidated: 0, 
        },		
				documents: [],
				headers: [
					{ text: 'Fecha registro', value: "creationDate", sortable: true },
					{ text: 'Clave validación', value: "validationKey", sortable: true },
					{ text: 'Autor', value: "author", sortable: true },
					{ text: 'Título', value: "title", sortable: true },
					{ text: 'Fecha inicio validez', value: "validityStartDate", sortable: true },
					{ text: 'Fecha fin validez', value: "validityFinishDate", sortable: true },
					{ text: 'Habilitado', value: "enabled", sortable: true },       
					{ text: "", value: "actions", sortable: false, width: "90px" },
				],	
				disableDownloadIcon: false,	
      }
    },
    methods: {
			searchTimeOut() {
				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}
				this.timer = setTimeout(() => {
					this.options.page = 1;
					this.listarItems();
				}, 800);
			},
			refreshAll: function () {
				this.documents = [];
				this.loading = true;		

				const { sortBy, sortDesc, page, itemsPerPage } = this.options;

				api.getSessionInformation(
					(page - 1) * itemsPerPage,
					itemsPerPage,
					this.search ? this.search : "",
					sortBy,
					sortDesc,
					(data) => {
						this.loading = false;

						this.homeStats = {
							totalUploaded: data.uploaded,
							totalValidated: data.validated, 
						};

						this.documents = data.documents.entities;
						this.totalDocuments = data.documents.total;

						this.updateTime = this.formatLocalDateTime(new Date().getTime());
					},
					(error) => {
						this.loading = false;
						this.errorMessage = error;
						this.$log.error(error);
					}
				);
			},
			listarItems: function () {
				this.documents = [];
				this.apiLoading = true;	

				const { sortBy, sortDesc, page, itemsPerPage } = this.options;

				api.getDocuments(
					(page - 1) * itemsPerPage,
					itemsPerPage,
					this.search ? this.search : "",
					sortBy,
					sortDesc,
					(data) => {
						this.apiLoading = false;
						this.documents = data.entities;
						this.totalDocuments = data.total;
					},
					(error) => {
						this.apiLoading = false;
						this.errorMessage = error;
						this.$log.error(error);
					}
				);
			},
      openCreateDocumentDialog() {
				this.apiLoading = true;

				api.createDocument(
					(data) => {
						this.apiLoading = false;
						this.$refs.documentDialog.showDialog(data, true, () => {
							this.listarItems();
						});
					},
					(error) => {
						this.apiLoading = false;
						this.errorMessage = error;
						this.$log.error(error);
					}
				);
			},
      openEditDocumentDialog(item) { 
				this.$refs.documentDialog.showDialog(item, false, () => {
					this.listarItems();
				});
			},
			downloadFile(item) { 				
				this.disableDownloadIcon = true;

				api.downloadDocument(item.id, 
					() => { 
						this.disableDownloadIcon = false;
					}, 
					() => { 
						this.disableDownloadIcon = false; 
					});
			},
    },
    watch: {
			options: {
				handler() {
					this.$log.warn(this.options);
					this.listarItems();
				},
				deep: true,
			},
			// eslint-disable-next-line no-unused-vars
      $route(to, from) {
					this.refreshAll();
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
					vm.refreshAll();
      })
    },
  }
</script>